// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gPVV","colMin":"styles_colMin__1f8lY"};